import { inject, Injectable } from '@angular/core';
import { HttpUtils } from '@core/utils/http-utils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { ResultsImportSummaryDialogComponent } from '../components/results/results-import-summary-dialog/results-import-summary-dialog.component';
import { ClearErrorsAction } from '../store/result-import.actions';
import { ResultImportFilter } from '../store/result-import.state';

@Injectable({
  providedIn: 'root',
})
export class ResultsImportUtilsService {
  private ngbModal = inject(NgbModal);
  private store = inject(Store);

  public buildHttpParams(params: ResultImportFilter) {
    let httpParams = HttpUtils.buildHttpParams(params);

    if (params.ids?.length) {
      httpParams = httpParams.set('ids', params.ids.join(','));
    }

    if (params.laboratory) {
      httpParams = httpParams.set('laboratory', params.laboratory);
    }

    return httpParams;
  }

  public openImportSummary(resultImportId: string) {
    const modalRef = this.ngbModal.open(ResultsImportSummaryDialogComponent, {
      centered: true,
      backdrop: 'static',
      modalDialogClass: 'modal-size-xxl',
    });

    modalRef.componentInstance.importId.set(resultImportId);

    modalRef.hidden.subscribe(() => {
      this.store.dispatch(new ClearErrorsAction());
    });
  }
}
